import react, { useEffect, useState } from 'react';
import { Disclosure } from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { getParentFaq } from '../../app/api';


// const faqs = [
//   {
//     title: "Манай цогцолборт амрах хугацаандаа:",
//     question: "Амрагч хүүхдийн мөрдөх журам",
//     answer:
//       `Амралтын хугацаанд  өөрт тань тааламжгүй, ойлгомжгүй асуудал гарвал хамгийн түрүүнд бүлгийн удирдагчдаа хэлж, яаралтай арга хэмжээ авахуулна.
//       /Амралтын бүсэд байгаа болон бий болсон орчны аюулгүй байдалд өөрийн зүгээс хянамгай байж, аливаа осол гэмтлээс урьдчилан сэргийлнэ.
//       /Амарч байх хугацаанд биед гарсан эрүүл мэндийн аливаа өөрчлөлтийг цаг алдалгүй бүлгийн удирдагчдаа мэдэгдэж, яаралтай тусламж авна.
//       /Нэг бүлэг, өрөөнд амарч буй найз нөхөд, ах эгч, дүү нараа хүндэлж,  харилцааны эерэг уур амьсгалыг эрхэмлэнэ.
//       /Бусад амрагчдад тулгарсан асуудлыг эерэгээр шийдвэрлэх алхамыг хийж, тэдэнтэй найзалж, нөхөрлөн шаардлагатай үед нь тусална.
//       /Зуслангийн өдрийн дэглэм, хөгжлийн хөтөлбөрт оролцохдоо  хувийн соёл, цаг баримтлалийг өөртөө хэвшүүлж, идэвхи санаачилгатай байна.
//       /Зуслангийн ажилтан, албан хаагчдын хөдөлмөрийг хүндэлж, ойлгомжгүй зүйлээ асууж тодруулна.
//       /Нэгдсэн менежементийн тогтолцоог хэрэгжүүлж буй манай Цогцолборын байгалийн баялаг болсон ургамал, амьтан ногоон байгууламжид хайр гамтай хандана.
//       /Манай зусланд интернэтийн хэрэглээг хязгаарладаг тул гар утасны хэрэглээндээ анхаарна.
//       /QR код бүхий эрхийн бичгээ сайтар хямгадаж, гээгдүүлэхгүй байхад анхаарна.
//       `,
//   },
//   {
//     title:
//       "Эрүүл мэндийн хуудсыг татан авч эх хүүхдийн эрүүл мэндийн үндэсний төвийн Зүүн талаас (зурагт) хашаагаар ороод 2 давхар Үргүйдэл нөхөн үржихүйн төвийн байранд заавал шинжилгээ хийлгэж тэмдэглүүлнэ.",
//     question: "Эрүүл мэндийн үзлэг",
//     link: true,
//     answer:
//       "Хүүхдийн эмчид үзүүлэх /  Арьс өнгөний үзлэг /  Шимэгч хорхойн шинжилгээ / Шээсний шинжилгээ",
//     data: "Ээлжийн эхний өдөр “Найрамдал” цогцолборын эмчийн урьдчилан сэргийлэх үзлэгээр тэнцээгүй/ шинжилгээ хийлгээгүй, эмчилгээ шаардлагатай өвчлөл илэрсэн/ хүүхдийг өдөрт нь эцэг эхэд нь мэдэгдэж, “Гараас гарт” буцаахыг анхаарна уу.",
//   },
//   {
//     title: "",
//     question: "Зусланд юу авч явах вэ?",
//     answer:
//       `Өндөр үнэ өртөгтэй  алт үнэт эдлэл, гар утас, видео камер, гэрэл зургийн аппарат, ганган чамин хувцас, хэрэглэл амралтын хугацаанд төдийлөн хэрэглэгддэггүй тул шаардлагагүй, авч ирсэн бол бүлгийн удирдагчийн бүртгэлд бүртгүүлж, өөрөө хариуцлага хүлээнэ. 
//       /Манай цогцолборт тусгай дүрэмт хувцас өмсөх шаардлагагүй, гэхдээ хөгжлийн хөтөлбөрийн үйл ажиллагаа байнгын хөдөлгөөн, өөрийн оролцоог эрхэмлэж, өдрийн турш идэвхитэй байдаг тул дотор болон гадаа өмсөх биед эвтэйхэн нимгэн зөөлөн, дулаан хувцас (хүрэм, ноосон цамц, ємд, борооны цув, бусад) хэрэгтэй. Мөн өөрийн хувцсандаа гамтай байж, гээхгүй, орхихгүй байхад анхаарна.
//       /Ариун цэврийн хэрэглэл (шүдний оо, сойз, гар нүүрийн алчуур шампунь сам , бусад), өрөөний болон усны шаахай, зэргийг бэлтгэж ирнэ.
//       /Амны хаалт, гар ариутгагч заавал хэрэгтэй.
//       /Өөрийн биеийн эрүүл мэнддээ анхаарч тогтмол хэрэглэдэг эм байвал эцэг эхийн зөвшөөрлөөр авч ирж, эмчид мэдэгдэн тогтмол хэрэглэхийг мартуузай.
//       /Хүүхэд бүр өөрийн усны савтай ирнэ. 
//       /Өөрийн заавал хэрэглэгдэг хүнсний нэмэлт бүтээгдэхүүнийг авч ирж болох ч, бэлэн гоймон, хийтэй ундаа, мах махан бүтээгдэхүүн, лаазалсан болон амархан мууддаг жимс жимсгэнэ, өндөг, хайлж урсдаг чихэр түүнтэй адилтгах зүйлийг хориглодог тул анхааралтай хандана уу.
//       `,
//   },
//   {
//     title: "",
//     question: "Манай цогцолборт амрах хуацаанд хориглох зүйлс:",
//     answer:
//       `Тэжээвэр амьтан авч ирэхийг
//       /Гал асаагуур, лаа, үсний индүү, үсний сэнс, халаагуур авч ирэхийг
//       /Бүх төрлийн тоглоомон буу (усан буу, үрлэн сумтай буу)-тай ирэхийг
//       /Хурц иртэй, хайч, хутга, үзүүртэй зүйлс, цаасны хутгатай байхыг
//       /Найрлага нь тодорхой бус бодис, эм, тариа авч ирэхийг
//       /Архи согтууруулах ундааны төрөл, утаат болон цахилгаан тамхитай байхыг
//       /Үнэтэй эд эдлэл (дрон, зургийн аппарат, их хэмжээний бэлэн мөнгө, зөөврийн таблет эсвэл компьютер)-тэй байхыг
//       /Лазераар заагч гэрэл ав ирэхийг
//       /Хог хаягдлыг ил задгай хаяхыг
//       /Ой мод, аж ахуйн бүс, өөрийн бүлгээс бусад хэсэг рүү бүлгийн удирдагчийн зөвшөөрөлгүй явахыг
//       /Хурдан муудах хүнсний бүтээгдэхүүн (мах махан бүтээгдэхүүн, лаазалсан бүтээгдэхүүн, өндөгний орцтой бүтээгдэхүүн) авч ирэхийг
//       `,
//   },
// ];

const faqsEnd = [
  {
    question: "Автобусны аюулгүй байдлын дүрэм юу вэ?",
    answer: `Суудлын бүсийг заавал зүүх Автобус хөдлөх үед босохгүй байх Автобусанд юм идэх хориотой Суудал дээрээс эргэж харах, босож зогсох, үсрэхгүй байх  Бүлгийн удирдагчийн заавар зөвлөгөөг биелүүлэх`,
  },
  {
    question: "Хоцорсон үед яах вэ?",
    answer:
      "Ээлжийн цуваанаас хоцорсон тохиолдолд эцэг эхчүүд болон асран хамгаалагч нь цогцолборын байранд хүргэж өгөх асуудлыг бүрэн хариуцна. Амрагч хүүхдийн овог нэр, нас, хүйс, холбоо барих дугаар, цогцолборт ирэх цаг зэргийг тухайн өдрийн 12.00 цагаас өмнө 75056010  дугаарын (Амралтын төв байр)-тай холбогдон тэмдэглүүлнэ. Заасан хугацаанд дээрх мэдээллийг ирүүлээгүй тохиолдолд бүлэг хувиарлалтаас хоцрох тул хариуцлагатай хандахыг хүсч байна.",
  },
  {
    question: "Эргэлт хийх бол яах вэ?",
    answer:
      "Зуслан нь хүүхдийн бие даах чадвар нэмэгдүүлэх зорилготой орчин учраас “ЭРГЭЛТ” үйл ажиллагааг зохион байгуулахгүйг анхаарна уу.",
  },
  {
    question: "Бүлгийн мэдээлэл хэрхэн авах вэ?",
    answer:
      "Та хүүхдээ аль бүлэгт орсон, бүлгийн удирдагчтай холбогдох тохиолдолд тухайн ээлж эхэлсэн өдрийн 14,00 цагаас хойш 75056010 дугаарт (Амралтын төв байр) холбогдон хүүхдийнхээ овог, нэр, сургуулийг хэлж ямар бүлэгт хувиарлагдсаныг мэдэж болно.",
  },
];

interface FaqItem {
  title: string;
  content: string;
}

export default function Parent() {

  const [faqs, setFaqs] = useState<FaqItem[]>([]);


  useEffect(() => {
    getParentFaq()
      .then((res) => {
        setFaqs(res.data as FaqItem[]);
      })
      .catch((err) => console.error('Failed to load FAQs:', err))
  }, []);

  return (
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
        <img src="/parent_image.jpg" className="w-full mb-16 h-68 " />
        <div className="mx-auto max-w-4xl divide-y divide-gray-900/10">
          <h2 className="text-2xl font-bold leading-10 tracking-tight text-gray-900 italic">
            Эцэг эхийн булан
          </h2>
          <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
            {faqs.map((faq, index) => (
              <Disclosure as="div" key={index} className="pt-6">
                {({ open }) => (
                  <>
                    <dt>
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                        <span className="text-base font-semibold leading-7">
                          {faq.title}
                        </span>
                        <span className="ml-6 flex h-7 items-center">
                          {open ? (
                            <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
                          ) : (
                            <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <div
                        className="text-base leading-7 text-gray-600 [&>ul]:list-disc [&>ul]:pl-6 [&>ul>li]:mb-1"
                        dangerouslySetInnerHTML={{ __html: faq.content }}
                      />
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-6 py-24 sm:pt-32 lg:px-8 lg:py-40">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5">
            <h2 className="text-2xl font-bold leading-10 tracking-tight text-gray-900 italic">
              Түгээмэл асуулт хариултууд
            </h2>
          </div>
          <div className="mt-10 lg:col-span-7 lg:mt-0">
            <dl className="space-y-10">
              {faqsEnd.map((faq) => (
                <div key={faq.question}>
                  <dt className="text-base font-semibold leading-7 text-gray-900">
                    {faq.question}
                  </dt>
                  <dd className="mt-2 text-base leading-7 text-gray-600">
                    {faq.answer}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}
